<template>
<div>
    <!-- <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1> -->
    <!-- <H3 style="text-align:center">项目 {{basicFormData.projectName}}</H3> -->
    <el-descriptions class="" title="" :column="3" border size="small">
        <!-- <template slot="extra">
            <el-button type="primary" size="small">操作</el-button>
        </template> -->
        <el-descriptions-item label="询价单编码" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.rfqCode }}
        </el-descriptions-item>

        <el-descriptions-item label="任务名称" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.taskName }}
        </el-descriptions-item>

        <el-descriptions-item label="任务单号" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.taskCode }}
        </el-descriptions-item>

        <el-descriptions-item label="技术通知编码" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.technicalCode }}
        </el-descriptions-item>

        <el-descriptions-item label="询价创建时间" :label-style="getStyle()" :content-style="getStyle2()">
            {{ dateFormatValue(basicFormData.rfqCreateTime, "yyyy/MM/DD HH:mm:ss") }}
        </el-descriptions-item>

        <el-descriptions-item label="本轮报价截止时间" :label-style="getStyle()" :content-style="getStyle2()">
            <!-- {{ dateFormatValue(basicFormData.rfqStopTime) }} -->
            <!-- {{basicFormData.quotationStopTime}} {{disableDatePicker}} {{basicFormData.rfqStatus}} -->
            <el-date-picker size="small" v-if="!viewFlag && !disableDatePicker" v-model="basicFormData.quotationStopTime" format="yyyy/MM/dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options="pickerOptions"></el-date-picker>
            <span v-else>
                {{ dateFormatValue(basicFormData.quotationStopTime, "yyyy/MM/DD HH:mm:ss") }}
            </span>

        </el-descriptions-item>
        <el-descriptions-item label="价格小数点位数" :label-style="getStyle()" :content-style="getStyle2()">

            <el-select  v-if="!viewFlag && !disableDatePicker" v-model="basicFormData.priceBit" filterable placeholder="请选择小数点位数">
                <el-option key="2" label="2" :value="2" />
                <el-option key="3" label="3" :value="3" />
            </el-select>
            <span v-else>
                {{ basicFormData.priceBit }}
            </span>
            
        </el-descriptions-item>

        <el-descriptions-item label="询价状态" :label-style="getStyle()" :content-style="getStyle2()">
            {{ rfqStatusFormat(basicFormData.rfqStatus) }}
        </el-descriptions-item>

        <el-descriptions-item label="延期次数" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.delayTimes }}
        </el-descriptions-item>

        <el-descriptions-item label="轮次" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.times }}
        </el-descriptions-item>

        <el-descriptions-item label="项目名称" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.projectName }}
        </el-descriptions-item>

        <el-descriptions-item label="采购工程师" :label-style="getStyle()" :content-style="getStyle2()">
            {{ basicFormData.supplyEngineer }}
        </el-descriptions-item>

    </el-descriptions>
    <el-form :model="basicFormData" ref="basicForm" @keyup.enter.native="dataFormSubmit()" label-width="150px" class="org-dialog-form" v-show="false">
        <el-row :gutter="10">
            <el-col :span="8">
                <el-form-item label="询价单编码" prop="rfqCode">
                    <el-input v-if="!viewFlag" v-model="basicFormData.rfqCode" size="mini"></el-input>
                    <span v-else>{{basicFormData.rfqCode}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="项目名称" prop="rfqName">
                    <el-input v-if="!viewFlag" v-model="basicFormData.rfqName" size="mini"></el-input>
                    <span v-else>{{basicFormData.rfqName}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="任务单号" prop="taskCode">
                    <!-- 选择 -->
                    <el-input v-if="!viewFlag" v-model="basicFormData.taskCode" size="mini"></el-input>
                    <span v-else>{{basicFormData.taskCode}}</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <!-- <el-col :span="8">
                <el-form-item label="费用单号" prop="supportingPartner">
                    {{basicFormData.feeCode}}
                </el-form-item>
            </el-col> -->
            <el-col :span="8">
                <el-form-item label="技术通知编码" prop="technicalCode">
                    <el-input v-if="!viewFlag" v-model="basicFormData.technicalCode" size="mini"></el-input>
                    <span v-else>{{basicFormData.technicalCode}}</span>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
                <el-form-item label="提交人" prop="projectName">
                    {{basicFormData.submitor}}
                </el-form-item>
            </el-col> -->
        </el-row>
        <el-row :gutter="10">
            <el-col :span="8">
                <el-form-item label="询价创建时间" prop="rfqCreateTime">
                    <el-date-picker v-if="!viewFlag" v-model="basicFormData.rfqCreateTime" format="yyyy/MM/dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    <span v-else>{{dateFormatValue(basicFormData.rfqCreateTime, 'yyyy/MM/DD HH:mm:ss')}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="询价截止时间" prop="rfqStopTime">
                    <el-date-picker v-if="!viewFlag" v-model="basicFormData.rfqStopTime" format="yyyy/MM/dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    <span v-else>{{dateFormatValue(basicFormData.rfqStopTime, 'yyyy/MM/DD HH:mm:ss')}}</span>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="报价截止时间" prop="quotationStopTime">
                    <el-date-picker v-if="!viewFlag" v-model="basicFormData.quotationStopTime" format="yyyy/MM/dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options="pickerOptions"></el-date-picker>
                    <span v-else>{{dateFormatValue(basicFormData.quotationStopTime, 'yyyy/MM/DD HH:mm:ss')}}</span>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="8">
                <el-form-item label="询价状态" prop="projectName">
                    {{basicFormData.rfqStatus}}
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="延期次数" prop="projectName">
                    {{basicFormData.delayTimes}}
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="轮次" prop="projectName">
                    {{basicFormData.times}}
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="8">
                <el-form-item label="采购负责人" prop="supportingPartner">
                    {{basicFormData.supplyResponsor}}
                    <!-- 选择 -->
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="技术负责人" prop="supportingPartner">
                    {{basicFormData.techResponsor}}
                    <!-- 选择 -->
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="质量负责人" prop="supportingPartner">
                    {{basicFormData.qualityResponsor}}
                    <!-- 选择 -->
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</div>
</template>

<script>
import moment from 'moment'
import {
    RFQ_STATUS,
    RFQ_STATUS_VALUE,
    getLabelByValue
} from '@/utils/const'
export default {
    props: {
        basicFormData: Object,
        viewFlag: Boolean
    },
    computed: {
        disableDatePicker() {
            if (this.basicFormData) {
                if (this.basicFormData.rfqStatus === RFQ_STATUS.BEGIN) {
                    return false
                }
                if (this.basicFormData.rfqStatus === RFQ_STATUS.BEFORE_ASK || this.basicFormData.rfqStatus === RFQ_STATUS.ASKING) {
                    return !this.allowEditDate
                }
            }
            return true
        },
        minDate() {
            if (this.basicFormData.quotationStopTime) {
                const date = +new Date(this.basicFormData.quotationStopTime)
                const min = date > this.nowTime ? date : this.nowTime
                return new Date(min)
            }
            return new Date(this.nowTime)
        }
    },
    data() {
        return {
            pickerOptions: { //禁用当前日期之前的日期
                disabledDate(time) {
                    var dateTime = new Date();
                    dateTime=dateTime.setDate(dateTime.getDate()+1);
                    return time.getTime() < new Date(dateTime).getTime() - 8.64e7;
                },
            },
        }
    },
    methods: {
        /**改变日期禁用状态 */
        changeEnableDate() {
            this.allowEditDate = !this.allowEditDate
        },
        /**确认修改日期 */
        async confirmChangeDate() {

        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value, fmt) {
            if (!value) {
                return ''
            }
            fmt = fmt ? fmt : "YYYY-MM-DD"
            return moment(value).format(fmt)
        },
        dataFormSubmit() {
            if (!this.viewFlag) {
                this.$emit('basic-submit')
            }
        },
        rfqStatusFormat: function (value) {
            value = String(value)
            if (!value) {
                return ''
            }
            return getLabelByValue(RFQ_STATUS_VALUE, value)
        },
        getFormRef() {
            return this.$refs['basicForm']
        },
        getStyle() {
            return 'width: 140px; text-align: right'
        },
        getStyle2() {
            return 'width: 294.3px;'
        }
    }
}
</script>
